import React from 'react'
import { Box, Grid, Heading, Paragraph, Text } from 'grommet'
import { Button } from 'components/Button'
import { DatasetFileItems } from 'components/DatasetFileItems'
import { DatasetCopyLinkButton } from 'components/DatasetCopyLinkButton'
import { WarningMultiplexedSamples } from 'components/WarningMultiplexedSamples'
import { WarningMergedObjects } from 'components/WarningMergedObjects'
import { formatBytes } from 'helpers/formatBytes'
import { useCCDLDatasetDownloadModalContext } from 'hooks/useCCDLDatasetDownloadModalContext'

export const CCDLDatasetDownloadOption = () => {
  const { selectedDataset, setDownloadDataset } =
    useCCDLDatasetDownloadModalContext()

  const downloadLabel = 'Download Project'

  return (
    <Grid
      areas={[
        { name: 'header', start: [0, 0], end: [1, 0] },
        { name: 'body', start: [0, 1], end: [1, 1] },
        { name: 'footer', start: [0, 2], end: [1, 2] }
      ]}
      columns={['1/2', '1/2']}
      fill="vertical"
      margin={{ left: '8px', right: '8px' }}
      rows={['auto', '1fr', 'auto']}
    >
      <Box gridArea="header">
        <Heading level="3" size="small" margin={{ bottom: 'small' }}>
          Download Summary
        </Heading>
        <Box
          direction="row"
          gap="xlarge"
          margin={{ top: 'medium', bottom: 'small' }}
        >
          {selectedDataset.ccdl_project_id && (
            <Text weight="bold">
              Project ID: {selectedDataset.ccdl_project_id}
            </Text>
          )}
          <Text weight="bold">
            Size: {formatBytes(selectedDataset.computed_file.size_in_bytes)}
          </Text>
        </Box>
        {selectedDataset.includes_files_merged && <WarningMergedObjects />}
        {selectedDataset.includes_files_multiplexed && (
          <WarningMultiplexedSamples />
        )}
      </Box>
      <Box gridArea="body" margin={{ bottom: 'small' }}>
        <Paragraph>The download consists of the following items:</Paragraph>
        <DatasetFileItems dataset={selectedDataset} />
      </Box>
      <Box gridArea="footer" margin={{ top: 'large' }}>
        <Button
          primary
          alignSelf="start"
          aria-label={downloadLabel}
          label={downloadLabel}
          onClick={() => {
            setDownloadDataset(true)
          }}
        />
        <Box
          border={{ side: 'top', color: 'border-black', size: 'small' }}
          margin={{ top: 'xlarge' }}
          pad={{ top: 'large' }}
        >
          <DatasetCopyLinkButton dataset={selectedDataset} />
        </Box>
      </Box>
    </Grid>
  )
}

export default CCDLDatasetDownloadOption
